import "@mantine/core/styles.css"
import "@mantine/dates/styles.css"
import { MantineProvider, ColorSchemeScript } from "@mantine/core"
import { theme } from "./theme"
import type React from "react"

export const metadata = {
    title: "Configuration Page",
    description: "A configuration page built with Next.js and Mantine",
}

export default function RootLayout({ children }: { children: React.ReactNode }) {
    return (
        <html lang="en">
            <head>
                <ColorSchemeScript />
            </head>
            <body>
                <MantineProvider theme={theme} forceColorScheme="light">{children}</MantineProvider>
            </body>
        </html>
    )
}

